<template>
  <div class="app flex-row align-items-center" style="background-color: #f6f6f6 !important;">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8" lg="6">
          <b-card no-body class="p-4">
            <b-card-body>
              <h1> Reset your password </h1>
                <p class="text-muted">
                  <span>When the password is reset, the existing OTP will be initialized.</span>
                </p>
              <b-input-group class="mb-3">
                <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                <input :disabled="reset" type="text" class="form-control" placeholder="Username" v-model="model.username" @keyup.enter="otpToken()">
                <b-button :disabled="reset || lock_btn" variant="secondary" class="px-4" @click="otpToken()">Submit</b-button>
              </b-input-group>
              <b-input-group class="mb-3" v-if="reset">
                <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                <input type="password" class="form-control" placeholder="new password" v-model="model.password_new">
              </b-input-group>
              <b-input-group class="mb-3" v-if="reset">
                <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                <input type="password" class="form-control" placeholder="new password repeat" v-model="model.password_new_repeat" @keyup.enter="newPassword()">
              </b-input-group>
              <hr>
              <small>
                <b-badge v-if="model.password_new"  :variant="password_policy('number') ? 'success' : 'danger'"> Number </b-badge>
                <b-badge v-if="model.password_new"  :variant="password_policy('uppercase') ? 'success' : 'danger'"> Upper Characters </b-badge>
                <b-badge v-if="model.password_new"  :variant="password_policy('lowercase') ? 'success' : 'danger'"> Lower Characters </b-badge>
                <b-badge v-if="model.password_new"  :variant="password_policy('spacial') ? 'success' : 'danger'"> Special Characters </b-badge>
                <b-badge v-if="model.password_new"  :variant="password_policy('length') ? 'success' : 'danger'">
                  Min Length : {{password_meter.min_length}}
                </b-badge>
              </small>

              <b-button v-if="reset" variant="primary" class="form-control" @click="newPassword()">Submit</b-button>
              <b-button class="float-left" variant="link" @click="$router.push({ name: 'auth_login'})">Sign in</b-button>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>


<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
